module.exports = {
      id: "books-vikatan-usage",
      viewBox: "0 0 22 29.5",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#books-vikatan",
      toString: function () {
        return this.url;
      }
    }